var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-dropdown', {
    ref: "Filter",
    staticClass: "filter w-100",
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "flex-fill"
        }, [_vm._v(_vm._s(_vm.title))])];
      },
      proxy: true
    }])
  }, [_vm.showKeywordFilter ? _c('div', {
    staticClass: "search mb-2 px-2"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('b-form-input', {
    attrs: {
      "type": "search",
      "placeholder": "搜尋"
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "keyword"
    }
  })], 1) : _vm._e(), _vm._l(_vm.filters.filter(function (x) {
    return _vm.keyword == null || _vm.keyword == '' ? true : x.text.indexOf(_vm.keyword) >= 0;
  }), function (i) {
    return _c('div', {
      key: i.value,
      staticClass: "item py-1 px-3",
      on: {
        "click": function click($event) {
          return _vm.handleSelect(i);
        }
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('i', {
      class: "fa ".concat(_vm.selectedOptions.includes(i) ? 'fa-check-square-o' : 'fa-square-o', " mr-3"),
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', {
      class: "mb-0 px-3 py-2 badge badge-".concat(i.variant, " flex-fill")
    }, [_vm._v(_vm._s(i.text))])])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }